var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var _a;
import { Component, Prop } from 'vue-property-decorator';
import VueDialog from "../../interface/IVueDialog";
import { UrlHelper } from "../../helper/UrlWrapper";
import PrintConfigService from '../../api/PrintConfigService';
import CommonService from '../../api/CommonService';
import { Loading, Alert } from 'element-ui';
import PrintTitle from './components/PrintTitle.vue';
import PrintHead from './components/PrintHead.vue';
import PrintBody from './components/PrintBody.vue';
import PrintTail from './components/PrintTail.vue';
import DragTemplate from './components/DragTemplate.vue';
import 'element-ui/lib/theme-chalk/alert.css';
import { assign, sampleSize } from 'lodash';
import GlobalVue from "@/globalVue";
var ETemplateType;
(function (ETemplateType) {
    ETemplateType["purOrder"] = "1";
    ETemplateType["deliver"] = "3";
})(ETemplateType || (ETemplateType = {}));
function createModel() {
    return {
        template_title: '',
        template_type: 1,
        show_dimension: 1,
        show_type: 1,
        print_height_type: 2,
        print_height: '140',
        print_width_type: 1,
        print_width: '210',
        print_font_weight_type: 4,
        print_orientation: 2,
        print_font_weight: 400,
        print_title: '',
        table_header: {
            font_size: '5.2',
            line_height: '3.5',
            column_number: '2',
            column1: '120',
            column2: '120',
            column3: '120',
            is_show_home_page: '0'
        },
        table_header_column: [],
        table_footer: {
            font_size: '5.2',
            line_height: '6',
            signature: '库管签字__________送货人签字__________',
            is_show_on_end: '0',
            is_show_page_number: '1',
            is_show_sign_img: '0',
            is_show_official_seal: '0',
            is_show_auditor: '0',
            is_show_creator: '0'
        },
        table_footer_column: [],
        table_main: {
            is_summary: 1,
            font_size: '5.2',
            line_height: '3.5',
            align: 1,
            column_number: '1',
            is_show_current_page_count: '1',
            is_show_capital_count: '0',
            is_combine_shop_print: '0',
            is_page_print_title: '1',
        },
        table_title: {
            align: 2,
            font_size: '5.1',
            line_height: '6'
        },
        table_main_column: [],
        sort_type: 0,
        has_scm_business: 0,
    };
}
var AddPrintModelDialog = (function (_super) {
    __extends(AddPrintModelDialog, _super);
    function AddPrintModelDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rowData = null;
        _this.activeNames = ['1', '2', '3', '4', '5'];
        _this.configModel = createModel();
        _this.eTemplateType = ETemplateType;
        _this.pageTypeList = [];
        _this.printTitleItemList = [];
        _this.fontSizeList = [];
        _this.yesOrNoList = [
            {
                name: '是',
                value: 1
            },
            {
                name: '否',
                value: 0
            }
        ];
        _this.textAlignList = [
            {
                name: '靠左',
                value: 1
            },
            {
                name: '居中',
                value: 2
            },
            {
                name: '靠右',
                value: 3
            }
        ];
        _this.showTypeList = [];
        _this.tagSortList = [];
        _this.readonly = false;
        _this.mm2px = 3.779527559;
        _this.paperSizeType = 1;
        _this.print_size = 1;
        _this.paperSizeList = [
            { value: 0, label: '自定义宽高' },
            { value: 1, label: '70mm*50mm' },
            { value: 2, label: '80mm*50mm' },
            { value: 3, label: '60mm*40mm' },
            { value: 4, label: '50mm*30mm' },
            { value: 5, label: '40mm*30mm' },
        ];
        return _this;
    }
    AddPrintModelDialog.prototype.handleShowDimensionChange = function () {
        var val = configModel.show_dimension;
        if (val == 2 && this.configModel.template_type == 3 && this.configModel.table_main) {
            this.configModel.table_main.is_summary = 1;
        }
        this.getPrintTitleItemList(this.configModel.template_type);
    };
    AddPrintModelDialog.prototype.handlePaperSizeChange = function () {
        var _this = this;
        var _a = this, paperSizeList = _a.paperSizeList, paperSizeType = _a.paperSizeType;
        console.log("🚀 ~ AddPrintModelDialog ~ handlePaperSizeChange ~ paperSizeType:", paperSizeType);
        console.log("🚀 ~ AddPrintModelDialog ~ handlePaperSizeChange ~ paperSizeList:", JSON.stringify(paperSizeList));
        var loadingInstance = Loading.service({ fullscreen: true });
        this.print_size = paperSizeType == 0 ? 1 : paperSizeType;
        var value = paperSizeList.find(function (item) { return item.value === paperSizeType; }).label;
        if (paperSizeType && paperSizeType != 0) {
            var valueArr = value.split('*');
            this.configModel.print_width = valueArr[0].replace('mm', '') - 0;
            this.configModel.print_height = valueArr[1].replace('mm', '') - 0;
        }
        var params = __assign({ template_type: this.configModel.template_type, show_dimension: this.configModel.show_dimension, print_size: this.print_size }, this.supplierParam);
        this.service.getCreateTemplateDetail(params).then(function (res) {
            var _a;
            var data = res.data.data;
            _this.configModel.table_header_column.splice(0);
            (_a = _this.configModel.table_header_column).push.apply(_a, (data.table_header_column || []));
            loadingInstance.close();
        }).catch(function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        });
    };
    AddPrintModelDialog.prototype.created = function () {
        var _this = this;
        this.service = PrintConfigService.getInstance();
        this.commonService = CommonService.getInstance();
        this.getFontSizeList();
        if (this.extraParam && this.extraParam.template_id) {
            this.rowData = {
                template_id: this.extraParam.template_id
            };
        }
        if (this.rowData && this.rowData.template_id) {
            console.log("🚀 ~ AddPrintModelDialog ~ created ~  this.rowData.template_id:", this.rowData.template_id);
            this.getDetailTemplateDetail(this.rowData.template_id).then(function () {
                var template_type = _this.configModel.template_type;
                _this.getShowTypeList(template_type);
                _this.getPrintTitleItemList(_this.configModel.template_type);
                if (template_type == 1 || template_type == 3 || template_type == 8) {
                    _this.getTagSortCommon();
                }
                else if (template_type == 15 || template_type == 17) {
                    _this.getTagSort();
                }
                if (_this.rowData.source === 3) {
                    _this.readonly = true;
                }
            });
        }
        else {
            this.getPageTypeList();
            this.getCreateTemplateDetail().then(function () {
                _this.getShowTypeList(_this.configModel.template_type);
                _this.getPrintTitleItemList(_this.configModel.template_type);
                console.log(222, _this.configModel.template_type);
                if (_this.configModel.template_type == 1 || _this.configModel.template_type == 3 || _this.configModel.template_type == 8) {
                    _this.getTagSortCommon();
                }
            });
        }
    };
    AddPrintModelDialog.prototype.handleMm2pxChange = function (data) {
        this.mm2px = data;
    };
    AddPrintModelDialog.prototype.getPageTypeList = function () {
        var _this = this;
        this.service.getPageTypeList(this.supplierParam).then(function (res) {
            var data = res.data.data;
            _this.pageTypeList = data || [];
        });
    };
    AddPrintModelDialog.prototype.getPrintTitleItemList = function (template_type) {
        var _this = this;
        return this.service.getPrintTitleItemList(__assign({ template_type: template_type }, this.supplierParam)).then(function (res) {
            var data = res.data.data;
            _this.printTitleItemList = data.name || [];
        });
    };
    AddPrintModelDialog.prototype.getFontSizeList = function () {
        var _this = this;
        this.service.getFontSizeList(this.supplierParam).then(function (res) {
            var data = res.data.data;
            _this.fontSizeList = data || [];
        });
    };
    AddPrintModelDialog.prototype.getShowTypeList = function (template_type) {
        var _this = this;
        this.service.getShowTypeList(__assign({ template_type: template_type }, this.supplierParam)).then(function (res) {
            var data = res.data.data;
            _this.showTypeList = data || [];
        });
    };
    AddPrintModelDialog.prototype.handlePrintWidthTypeChange = function (type, value) {
        this.configModel.print_width = value;
    };
    AddPrintModelDialog.prototype.handlePrintHeightTypeChange = function (type, value) {
        this.configModel.print_height = value;
    };
    AddPrintModelDialog.prototype.handlePrintWeightTypeChange = function (type, value) {
        this.configModel.print_font_weight = this.configModel.print_font_weight_type * 100;
    };
    AddPrintModelDialog.prototype.changeTemplateType = function () {
        this.configModel.show_dimension = 1;
        this.configModel.show_type = 1;
        if (this.configModel.template_type == 16) {
            this.configModel.show_type = 4;
        }
        this.showTypeList = [];
        this.getShowTypeList(this.configModel.template_type);
        this.getCreateTemplateDetail();
        this.getPrintTitleItemList(this.configModel.template_type);
        if (this.configModel.template_type == 1 || this.configModel.template_type == 3 || this.configModel.template_type == 8) {
            this.getTagSortCommon();
        }
        else if (this.configModel.template_type == 15 || this.configModel.template_type == 17) {
            this.getTagSort();
        }
    };
    AddPrintModelDialog.prototype.getTagSort = function () {
        var _this = this;
        this.service.getTagSort(__assign({ template_type: this.configModel.template_type }, this.supplierParam)).then(function (res) {
            _this.tagSortList = Array.isArray(res.data.data) ? res.data.data : [];
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    AddPrintModelDialog.prototype.getTagSortCommon = function () {
        var _this = this;
        this.service.getTagSortCommon(__assign({ template_type: this.configModel.template_type }, this.supplierParam)).then(function (res) {
            _this.tagSortList = Array.isArray(res.data.data) ? res.data.data : [];
            console.log(1112, _this.tagSortList);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    AddPrintModelDialog.prototype.getCreateTemplateDetail = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        if (this.configModel.show_dimension == 2) {
            if ((!this.configModel.show_type)) {
                this.configModel.show_type = 1;
            }
            this.configModel.table_main.is_summary = 1;
        }
        var params = __assign({ template_type: this.configModel.template_type, show_dimension: this.configModel.show_dimension, show_type: this.configModel.show_type, print_size: this.print_size }, this.supplierParam);
        if (this.configModel.template_type !== 16) {
            if (params.show_dimension == 1)
                delete params.show_type;
        }
        if (this.configModel.template_type !== 21) {
            delete params.print_size;
        }
        return this.service.getCreateTemplateDetail(params).then(function (res) {
            var data = res.data.data;
            data.template_title = _this.configModel.template_title;
            if (_this.configModel.template_type == 15 || _this.configModel.template_type == 17) {
                data.sort_type = 3;
            }
            if ([3, 8].includes(data.template_type)) {
                data.table_main.is_summary = data.table_main.is_summary || 1;
            }
            console.log('getCreateTemplateDetail>>>', data);
            _this.updateConfigModel(data);
            if (_this.rowData && _this.rowData.template_id) {
                _this.configModel.template_id = _this.rowData.template_id;
            }
            _this.has_scm_business = data.has_scm_business;
            loadingInstance.close();
        }).catch(function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        });
    };
    AddPrintModelDialog.prototype.updatePrintType = function () {
        var _a = this, _b = _a.configModel, print_width = _b.print_width, print_height = _b.print_height, paperSizeList = _a.paperSizeList;
        var str = print_width + "mm*" + print_height + "mm";
        var index = paperSizeList.findIndex(function (item) { return item.label === str; });
        this.paperSizeType = index > -1 ? index : 0;
        console.log('updatePrintType>>>', index, print_width, print_height);
    };
    AddPrintModelDialog.prototype.updateConfigModel = function (newData) {
        function getType(value) {
            return Object.prototype.toString.call(value);
        }
        var defaultConfigModel = createModel();
        var newConfig = {};
        for (var key in this.configModel) {
            var value = newData[key] || defaultConfigModel[key];
            this.configModel[key] = value;
        }
    };
    AddPrintModelDialog.prototype.getDetailTemplateDetail = function (template_id) {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        return this.service.getDetailTemplateDetail(__assign({ template_id: template_id }, this.supplierParam)).then(function (res) {
            var data = res.data.data;
            if ([3, 8].includes(data.template_type)) {
                data.table_main.is_summary = data.table_main.is_summary || 1;
            }
            if (data.template_type === 19) {
                data.table_footer.is_show_auditor = data.table_footer.is_show_auditor || '0';
                data.table_footer.is_show_creator = data.table_footer.is_show_creator || '0';
            }
            _this.configModel = data;
            _this.updatePrintType();
            loadingInstance.close();
        }).catch(function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        });
    };
    AddPrintModelDialog.prototype.close = function () {
        GlobalVue.$emit("closeTab", this);
    };
    AddPrintModelDialog.prototype.dataProcess = function (data) {
        data.table_header = JSON.stringify(data.table_header);
        data.table_header_column = JSON.stringify(data.table_header_column);
        data.table_footer = JSON.stringify(data.table_footer);
        data.table_footer_column = JSON.stringify(data.table_footer_column);
        data.table_main = JSON.stringify(data.table_main);
        data.table_main_column = JSON.stringify(data.table_main_column);
        data.table_title = JSON.stringify(data.table_title);
        return data;
    };
    AddPrintModelDialog.prototype.saveCheckPass = function (data) {
        var header_column = ['name', 'is_hidden', 'is_show_code', 'sort'];
        if (data.template_type !== 21) {
            var _loop_1 = function (i, iLen) {
                var iRow = data.table_header_column[i];
                var flag = true;
                header_column.map(function (key) {
                    if (iRow[key] === undefined || iRow[key] === '')
                        flag = false;
                });
                if (!flag) {
                    this_1.$message.error("请填写所有必填字段，并且按字段格式要求填写");
                    return { value: false };
                }
            };
            var this_1 = this;
            for (var i = 0, iLen = data.table_header_column.length; i < iLen; i++) {
                var state_1 = _loop_1(i, iLen);
                if (typeof state_1 === "object")
                    return state_1.value;
            }
            var _loop_2 = function (i, iLen) {
                var iRow = data.table_main_column[i];
                var flag = true;
                if (!data.table_main_column[i]['value']) {
                    data.table_main_column[i]['value'] = data.table_main_column[i]['name'];
                }
                [
                    'name',
                    'is_hidden',
                    'column_width',
                    'is_wrap',
                    'is_summary',
                    'align',
                    'sort'
                ].map(function (key) {
                    if (iRow[key] === undefined || iRow[key] === '')
                        flag = false;
                });
                if (!flag) {
                    this_2.$message.error("请填写所有必填字段，并且按字段格式要求填写");
                    return { value: false };
                }
                if (iRow['column_width'] < 1 || (iRow['column_width'] + '').indexOf('.') > -1) {
                    this_2.$message.error("请填写打印主体的列宽，必须是大于0的整数");
                    return { value: false };
                }
            };
            var this_2 = this;
            for (var i = 0, iLen = data.table_main_column.length; i < iLen; i++) {
                var state_2 = _loop_2(i, iLen);
                if (typeof state_2 === "object")
                    return state_2.value;
            }
        }
        return true;
    };
    AddPrintModelDialog.prototype.validateScopes = function () {
        var arr = [
            this.$validator.validateScopes(),
        ];
        if (this.$refs.printTitle) {
            arr.push(this.$refs.printTitle.$validator.validateScopes());
        }
        if (this.$refs.printHead) {
            arr.push(this.$refs.printHead.$validator.validateScopes());
        }
        if (this.$refs.printTail) {
            arr.push(this.$refs.printTail.$validator.validateScopes());
        }
        if (this.$refs.printBody) {
            arr.push(this.$refs.printBody.$validator.validateScopes());
        }
        return Promise.all(arr).then(function (arr) {
            return arr.filter(function (v) { return v === true; }).length == arr.length;
        });
    };
    AddPrintModelDialog.prototype.save = function () {
        var _this = this;
        console.log(this.configModel);
        this.validateScopes().then(function (res) {
            if (!res) {
                _this.$message.error("请填写所有必填字段，并且按字段格式要求填写");
                return;
            }
            if (!_this.saveCheckPass(_this.configModel)) {
                return;
            }
            if (_this.configModel.template_type === 21) {
                _this.configModel.table_header_column.forEach(function (item) {
                    if (item.type == 4) {
                        item.height = item.width;
                    }
                    item.mm2px = _this.mm2px;
                });
            }
            if (_this.configModel.table_title == null) {
                _this.configModel.table_title = [];
            }
            var data = JSON.parse(JSON.stringify(_this.configModel));
            data = _this.dataProcess(data);
            assign(data, _this.supplierParam);
            var loadingInstance = Loading.service({ fullscreen: true });
            if (_this.rowData && _this.rowData.template_id) {
                _this.service.updConfig(data).then(function (res) {
                    loadingInstance.close();
                    _this.$message.success('修改成功！');
                    _this.close();
                    _this.$emit('editConfig:ok');
                }, function (err) {
                    loadingInstance.close();
                    _this.$message.error(err.message);
                }).catch(function (err) {
                    _this.$message.error(err.message);
                    loadingInstance.close();
                });
            }
            else {
                _this.service.addConfig(data).then(function (res) {
                    loadingInstance.close();
                    _this.$message.success('添加成功！');
                    _this.close();
                    _this.$emit('addConfig:ok');
                }, function (err) {
                    loadingInstance.close();
                    _this.$message.error(err.message);
                }).catch(function (err) {
                    _this.$message.error(err.message);
                    loadingInstance.close();
                });
            }
        });
    };
    AddPrintModelDialog.prototype.preview = function () {
        var _this = this;
        function randomString(len) {
            return sampleSize('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789', len).join('');
        }
        this.validateScopes().then(function (res) {
            if (!res) {
                _this.$message.error("请填写所有必填字段，并且按字段格式要求填写");
                return;
            }
            if (!_this.saveCheckPass(_this.configModel)) {
                return;
            }
            window.sessionStorage.setItem('PRINT_CONFIG_PREVIEW_TEMPDATA', JSON.stringify(_this.configModel));
            var url = "./static/js/print/print2.html";
            url = UrlHelper.addParam(url, 'type', "printTemplate");
            url = UrlHelper.addParam(url, 'template_id', 'example');
            if (_this.user && _this.user.token) {
                url = UrlHelper.addParam(url, 'token', _this.user.token);
            }
            else if (Object.keys(_this.extraParam).length > 0) {
                for (var key in _this.extraParam) {
                    if (key !== 'template_id') {
                        url = UrlHelper.addParam(url, key, _this.extraParam[key]);
                    }
                }
            }
            if (_this.scene !== 'supplier') {
                UrlHelper.windowOpenIntercept(url);
                return;
            }
            var sign = randomString(10);
            url = UrlHelper.addParam(url, 'dataSign', sign);
            _this.service.setPreviewData({
                key: "pt" + ((_this.extraParam && _this.extraParam.template_id) || ''),
                value: JSON.stringify(_this.configModel),
                sign: sign
            }).then(function (res) {
                console.log('res>>>', res);
                if (res.data.success) {
                    url = UrlHelper.addParam(url, 'key', res.data.data.key);
                }
            }).finally(function () {
                UrlHelper.windowOpenIntercept(url);
                console.log('url>>>', url);
            });
        });
    };
    __decorate([
        Prop({
            type: String,
            default: 'platform'
        })
    ], AddPrintModelDialog.prototype, "scene", void 0);
    __decorate([
        Prop({
            type: Object,
            default: {}
        })
    ], AddPrintModelDialog.prototype, "extraParam", void 0);
    AddPrintModelDialog = __decorate([
        Component({
            components: (_a = {
                    PrintTitle: PrintTitle,
                    PrintHead: PrintHead,
                    PrintBody: PrintBody,
                    PrintTail: PrintTail,
                    DragTemplate: DragTemplate
                },
                _a[Alert.name] = Alert,
                _a),
            computed: {
                showTemplateDimension: function () {
                    var hideDimensionType = [4, 5, 6, 10, 12, 11, 13, 14, 15, 16, 17, 19, 20, 18, 21];
                    return hideDimensionType.indexOf(this.configModel.template_type) === -1;
                },
                supplierParam: function () {
                    return this.scene === 'supplier' ? __assign({}, this.extraParam, { scene: this.scene }) : {};
                }
            }
        })
    ], AddPrintModelDialog);
    return AddPrintModelDialog;
}(VueDialog));
export default AddPrintModelDialog;
